import { AgentWalletTransactionType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const agentWalletTransactionTypeName: { [key in AgentWalletTransactionType]: TKeyType } = {
  [AgentWalletTransactionType.RECHARGE]: 'common.recharge',
  [AgentWalletTransactionType.REVOKE]: 'common.revoke2',
  [AgentWalletTransactionType.IN]: 'common.agentWalletTransfer',
  [AgentWalletTransactionType.OUT]: 'common.agentWalletTransfer',
  [AgentWalletTransactionType.DEPOSIT]: 'common.deposit',
  [AgentWalletTransactionType.WITHDRAW]: 'common.playerWithdraw',
  [AgentWalletTransactionType.TOP_UP]: 'common.topUp',
  [AgentWalletTransactionType.DEDUCT]: 'common.deduct2',
  [AgentWalletTransactionType.MANUAL_DEPOSIT]: 'common.manualDeposit',
  [AgentWalletTransactionType.TRANSFER]: 'common.agentWalletTransfer'
}

export default agentWalletTransactionTypeName
